import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const getCompaniesUnsignedAgreementsStatus = (axios: IAxiosInstance) => {
  return async () => {
    const response = await axios.noRetry.get<ZealApiResponse<boolean>>(
      "/api/companies/unsigned-agreements-status"
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
